import { Paginate, ParamsType } from "@/types/global";
import fetcher from "@/lib/fetcher";
import { buildUrlQueryParams } from "@/utils/build-url-query-params";
import { CategoriesResponse, Category } from "@/types/category";

type CategoriesListResponse = {
  data: { data: CategoriesResponse[]; total: number };
};

export const categoryService = {
  getAll: (params?: ParamsType) =>
    fetcher<Paginate<Category>>(
      buildUrlQueryParams("v1/rest/categories/paginate", params),
    ),
  getAllCategories: (params?: ParamsType) =>
    fetcher<CategoriesListResponse>(
      buildUrlQueryParams("users/categories/filter", params),
    ),
  getCompanyCategories: (params?: ParamsType) =>
    fetcher<CategoriesListResponse>(
      buildUrlQueryParams("admin/company-products/categories", params),
    ),
  getCategoriesForUser: (isCompanyUser: boolean, params?: ParamsType) =>
    isCompanyUser
      ? categoryService.getCompanyCategories(params)
      : categoryService.getAllCategories(params),
};
